import { SessionGuardService } from 'src/app/services/session-guard.service';
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { showsDeliveryTabs } from 'src/app/core/delivery-channel';
import { log } from 'src/app/core/log';
import { BUSINESS_NAV_ITEMS, type NavItem, dailyNavItems } from 'src/app/core/nav-items';
import { ApisService } from 'src/app/services/apis.service';
import { ShiftService } from 'src/app/services/shift.service';
import { ThemeService } from 'src/app/services/theme.service';

/**
 * La barra lateral de PC (desde 992 px, dentro del `ion-split-pane` de `AppComponent`). Los
 * destinos diarios son los mismos de la barra inferior (`dailyNavItems`); «Mi negocio» va
 * aparte y «Cerrar sesión», al pie, separado de todo lo demás.
 *
 * `uid` lo pasa `AppComponent`: `null` en login, registro y recuperación, donde no hay venue
 * que escuchar.
 */
@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  standalone: false
})
export class SideNavComponent implements OnChanges, OnDestroy {
  @Input() uid: string | null = null;

  daily: NavItem[] = dailyNavItems(true);
  readonly business = BUSINESS_NAV_ITEMS;
  private venueSubscription?: Subscription;

  constructor(
    private api: ApisService,
    private navCtrl: NavController,
    private shift: ShiftService,
    public theme: ThemeService,
    private session: SessionGuardService
  ) {}

  ngOnChanges() {
    this.venueSubscription?.unsubscribe();
    this.venueSubscription = undefined;
    this.daily = dailyNavItems(true);
    if (!this.uid) {
      return;
    }
    //  En vivo, como `TabsPage`: si el admin suspende delivery, Comanda y Analíticas se van.
    this.venueSubscription = this.api.watchVenue(this.uid).subscribe({
      next: (venue) => (this.daily = dailyNavItems(showsDeliveryTabs(venue))),
      error: (error) => {
        log(error);
        this.session.handleError(error);
      }
    });
  }

  ngOnDestroy() {
    this.venueSubscription?.unsubscribe();
  }

  logout() {
    // Igual que la cuenta: cerrar sesión cierra el turno.
    this.shift.close();
    void this.api.logout().then(() => {
      void this.navCtrl.navigateRoot(['login']);
    });
  }

  trackByUrl(_index: number, item: NavItem): string {
    return item.url;
  }
}
